/**
 * One row of an association list, shared by the direction and the catalog panel.
 *
 * The status chip and the action used to hang off MUI's `secondaryAction`, which pins them to the
 * row's right edge. In a wide dialog that left the text at one end and its own status four hundred
 * pixels away at the other, so reading which chip belonged to which row meant tracking across empty
 * space. They sit together now, and the text takes the space that is left.
 *
 * Defined once so a direction and a catalog approval cannot drift into two different row shapes.
 */

export const ROW_SX = { gap: 1, alignItems: 'flex-start', py: 0.75 };

// minWidth 0 is what actually lets a long direction ellipsis instead of shoving the chip off the
// row: a flex child defaults to its content's width, however narrow the container gets.
export const TEXT_SX = { flex: '1 1 auto', minWidth: 0, my: 0 };

export const ACTION_GROUP_SX = {
  display: 'flex',
  gap: 0.5,
  alignItems: 'center',
  flexShrink: 0,
};
